import React, { Component } from 'react';
import { Text, TextInput, StyleSheet, View } from 'react-native';


export default function EonnField(props) {
  
    const [text, changeText] = React.useState(props.value ?? "");

    const styles = StyleSheet.create({
      inputWrapper: {
        maxWidth: '85%',
        margin: 10,
      },
      inputContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        width: 500,
        maxWidth: '100%',
      },
      input: {
        color: '#2e303e',
        fontSize: 18,
        fontFamily: 'nunito',
        lineHeight: 21,
        borderWidth: 1,
        borderColor: (( props.showRequired && !text ) || ( props.showError )) ? '#e96556' : '#9597a3',
        paddingTop: 7,
        paddingRight: 14,
        paddingBottom: 7,
        paddingLeft: 14,
        width: '100%',
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlignVertical: props.lines ? 'top' : 'center',
      },
      inputSolo: {
        color: '#2e303e',
        fontSize: 18,
        fontFamily: 'nunito',
        lineHeight: 21,
        borderWidth: 1,
        borderColor: (( props.showRequired && !text ) || ( props.showError )) ? '#e96556' : '#9597a3',
        paddingTop: 7,
        paddingRight: 14,
        paddingBottom: 7,
        paddingLeft: 14,
        width: 500,
        maxWidth: '100%',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlignVertical: props.lines ? 'top' : 'center',
      },
      errorMessage: {
        backgroundColor: '#e96556',
        color: '#ffffff',
        fontSize: 12,
        paddingTop: 3,
        paddingRight: 14,
        paddingBottom: 4,
        paddingLeft: 14,
        marginTop: 0,
        marginRight: 10,
        marginBottom: 0,
        marginLeft: 10,
      },
      label: {
        color: '#2e303e',
        fontSize: 18,
        fontFamily: 'nunito',
        lineHeight: 21,
        marginBottom: 5,
      },
      helpText: {
        color: '#2e303e',
        fontSize: 16,
        fontFamily: 'nunito',
        lineHeight: 21,
        paddingTop: 7,
        paddingRight: 5,
        paddingBottom: 7,
        textAlignVertical: props.lines ? 'top' : 'center',
        flexShrink: 0,
      },
    });

    const {value, showRequired, showError, lines, onChange, children, helpText, ...extraProps} = props;
    
    return (

      <View style={[styles.inputWrapper, props.inputWrapperStyle]} >
        <Text style={[styles.label, props.labelStyle]}>{props.children}</Text>
        {props.helpText ? (
          <View style={styles.inputContainer}>
            <Text style={[styles.helpText, props.helpTextStyle]}>{props.helpText}</Text>
            <TextInput
              style={[styles.input, props.inputStyle]}
              onChangeText={updatedText => { 
                changeText(updatedText);
                props.onChange?.(updatedText);
              }}
              value={text}
              //placeholder={props.children}
              multiline={props.lines ? true : false}
              numberOfLines={props.lines ?? 1}
              {...extraProps}
            />
          </View>
        ) : (
          <TextInput
            style={[styles.inputSolo, props.inputStyle]}
            onChangeText={updatedText => { 
              changeText(updatedText);
              props.onChange?.(updatedText);
            }}
            value={text}
            //placeholder={props.children}
            multiline={props.lines ? true : false}
            numberOfLines={props.lines ?? 1}
            {...extraProps}
          />
        )}
        { props.showRequired && !text &&
          <Text style={styles.errorMessage}>This field is required</Text>
        }
      </View>
    );
}

